import Media from './media';

export class PdpImageWell {
  id: string | undefined;
  mobileProductImages?: Media[];
  desktopProductImages?: Media[];
  desktopThumbnailImages?: Media[];

  constructor(props: any) {
    if (!props) return;

    this.id = props.sys?.id;
    this.mobileProductImages = props.mobileProductImagesCollection?.items?.map(
      (img: any) => new Media(img)
    );
    this.desktopProductImages =
      props.desktopProductImagesCollection?.items?.map(
        (img: any) => new Media(img)
      );
    this.desktopThumbnailImages =
      props.desktopThumbnailImagesCollection?.items?.map(
        (img: any) => new Media(img)
      );
  }
}

export default PdpImageWell;
